<template>
  <div class="container-fluid springter-section">
    <lang-menu></lang-menu>
    <div class="row">
      <div class="col-12">
        <logo type="white" @click.native="$ksvuefp.$emit('ksvuefp-nav-click', {nextIndex: 0})"></logo>
      </div>
    </div>
    <div class="section-content">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <h4>{{ $t('section3Title')}}</h4>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-3 col-lg-2 col-md-12 col-sm-12">
        </div>
        <div class="col-xl-6 col-lg-8 col-md-10 col-sm-12 pull-sm-0 push-sm-0 pull-md-1 push-md-1 pull-lg-0 push-lg-0">
          <div class="slider">
            <div class="row">
              <div class="col-md-1 hidden-sm-down">
                <div class="arrow-col">
                  <div class="button-wrapper">
                    <arrow-button @click.native="previous()" direction="left"></arrow-button>
                  </div>
                </div>
              </div>
              <div class="col-md-10 col-sm-12">
                <div class="slider__wrapper" v-if="mounted">
                  <flickity ref="flickity" :options="flickityOptions">
                    <div class="carousel-cell">
                      <p>{{ $t('section3Question1')}}</p>
                    </div>
                    <div class="carousel-cell">
                      <p>{{ $t('section3Question2')}}</p>
                    </div>
                    <div class="carousel-cell">
                      <p>{{ $t('section3Question3')}}</p>
                    </div>
                    <div class="carousel-cell">
                      <p>{{ $t('section3Question4')}}</p>
                    </div>
                    <div class="carousel-cell">
                      <p>{{ $t('section3Question5')}}</p>
                    </div>
                    <div class="carousel-cell">
                      <p>{{ $t('section3Question6')}}</p>
                    </div>
                    <div class="carousel-cell">
                      <p>{{ $t('section3Question7')}}</p>
                    </div>
                    <div class="carousel-cell">
                      <p>{{ $t('section3Question8')}}</p>
                    </div>
                  </flickity>
                </div>
              </div>
              <div class="col-md-1 hidden-sm-down">
                <div class="arrow-col arrow-col--right">
                  <div class="button-wrapper">
                    <arrow-button @click.native="next()" direction="right"></arrow-button>
                  </div>
                </div>
              </div>
              <div class="col-md-12 hidden-sm-up">
                  <arrow-button @click.native="previous()" direction="left"></arrow-button>
                  <arrow-button @click.native="next()" direction="right"></arrow-button>
              </div>
            </div>
          </div>
          <div class="triangle"></div>
          <div class="girl-image">
            <img src="../assets/img/02_small.png" alt="girl" />
          </div>
          <a class="button" href="#" role="button" @click.prevent="$ksvuefp.$emit('ksvuefp-nav-click', {nextIndex: 3})">
            <span>{{ $t('section3Button')}}</span>
            <br/>
            <span class="our-answer">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20px" height="20px" viewBox="0 0 35 60" xml:space="preserve">
                <polyline fill="none" stroke-width="20" stroke-linecap="round" stroke-linejoin="round" points="0.375,0.375 45.63,38.087 0.375,75.8 " />
              </svg>
            </span>
          </a>
        </div>
        <div class="col-xl-3 col-lg-2 col-md-12 col-sm-12"></div>
      </div>
    </div>
  </div>
</template>

<script>

import Flickity from 'vue-flickity';
import Logo from './shared/Logo';
import ArrowButton from './shared/ArrowButton';
import LangMenu from './shared/LangMenu';

export default {
  name: 'springter-section-3',
  components: {
    Logo,
    ArrowButton,
    Flickity,
    LangMenu,
  },
  data() {
    return {
      mounted: false,
      flickityOptions: {
        initialIndex: 0,
        prevNextButtons: false,
        pageDots: true,
        wrapAround: true,
        setGallerySize: false,
        autoPlay: 5000,
      },
    };
  },
  mounted() {
    setInterval(() => {
      this.mounted = true;
    }, 400);
  },
  methods: {
    next() {
      this.$refs.flickity.next();
    },
    previous() {
      this.$refs.flickity.previous();
    },
  },
};
</script>

<style lang="scss" scoped>

.springter-section{
  background-image: -moz-linear-gradient(-45deg, $c--white 0%, $c--white 35%, $color--brand-primary 35%,  $color--brand-primary 100%);
  background-image: -webkit-linear-gradient(-45deg, $c--white 0%, $c--white 35%, $color--brand-primary 35%, $color--brand-primary 100%);
  background-image: linear-gradient(160deg, $c--white 0%,$c--white 35%, $color--brand-primary 35%, $color--brand-primary 100%);
}

.our-answer {
  transform: rotate(90deg);
  stroke: $c--black;
  stroke-width: 10;
  display: inline-block;

  svg {
    padding: 5px;
    overflow: visible;
  }
}

.slider {
  background-color: $c--white;
  padding: 30px 15px 20px;
  margin-top: 40px;
  width: 100%;
  height: 250px;
  border: 5px solid $color--brand-primary;
  border-bottom-width: 0;

  @include mq('phablet', 'max') {
      padding: 30px 10px;
      height: 220px;
      margin-top: 25px;
  }

  &__wrapper {
    width: 100%;
    height: 180px;
    overflow: hidden;

     @include mq('phablet', 'max') {
      height: 140px;
    }
  }

  .flickity-enabled {
    height: 155px;

    @include mq('phablet', 'max') {
      height: 115px;
    }

    .carousel-cell {
      width: 100%;
      text-align: center;
    }
  }

  p {
    font-size: $p--large;
    width: 100%;

    @include mq('tablet-wide', 'max') {
      font-size: $p--large;
    }
    @include mq('phablet', 'max') {
      font-size: $p--large;
    }
    @include mq('phone-wide', 'max') {
      font-size: $p;
    }
    @include mqlandscape(){
      font-size: $p;
    }
  }

  .arrow-col {
    display: table;
    height: 100%;
    padding-left: 0;

    &--right{
      float: right;
    }
  }

  .button-wrapper {
    display: table-cell;
    vertical-align: middle;
    height: 100%;
  }

  button.arrow {
    display: block;

    @include mq('phablet', 'max') {
      border: none;
    }
    @include mqlandscape(){
      border: none;
    }
  }
}

.triangle {
  width: 0;
  height: 0;
  border-left: 10px solid $color--white;
  border-bottom: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid $color--white;
  margin-left: 60%;
  @include mq('tablet', 'max') {
      display: none;
  }
}

.girl-image {
  z-index: 1;
  position: relative;
  top: -80px;
  margin-left: 32%;
  
  @include mq('desktop-full', 'max') {
      margin-left: 29%;
  }
  @include mq('desktop-wide', 'max') {
      margin-left: 25%;
  }
  @include mq('desktop', 'max') {
      margin-left: 25%;
  }
  @include mq('tablet-wide', 'max') {
      margin-left: 29%;
  }
  @include mq('tablet', 'max') {
      margin-left: 25%;
  }
  @include mq('phablet', 'max') {
      margin-left: 20%;
  }
}

.button {
  z-index: 3;
  position: absolute;
  top: 60%;
  left: 50%;
  margin-left: -100px;
  @include mq('tablet', 'max') {
      top: 50%;
      margin-left: -80px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/SpringterSection3.vue